import { createFileRoute } from "@tanstack/react-router"
import { SpecializationCatalogsListPage } from "@/pages/specialization-catalogs"

export const Route = createFileRoute("/specialization-catalogs")({
	component: SpecializationCatalogsListPage,
	staticData: {
		breadcrumbKey: "navigation.specializationCatalogs",
	},
})
